/* DON'T EDIT THIS FILE: edit original and run build again */ import { DocumentToFulfill } from "../../../credit/autocomplete-files/types.ts";
import { LineOptions } from "../../../framework/tenant-handler-type/line-options.ts";
import { OnboardingOptions } from "../../../framework/tenant-handler-type/onboarding-options.ts";
import { SgrTenantHandler } from "../../../framework/tenant-handlers/sgr-tenant-handler.ts";
import { ComponentType, SVGProps } from "react";
import { bindGarantiasLineOptions } from "./bindgarantias-line-options.ts";
import { bindOnboardingOptions } from "./bindgarantias-onboarding-options.ts";
import { bindGarantiasTenant } from "./code.ts";
import { documentsToFulfill } from "./documents-to-fulfill.ts";
import { bindGarantiasFullLabel } from "./full-label.ts";
import { bindGarantiasLabel } from "./label.ts";

class BindGarantiasTenantHandler extends SgrTenantHandler {
  async getAuthPageLogo(): Promise<ComponentType<SVGProps<SVGElement>>> {
    // @ts-expect-error the hook is auto generated
    return (await import("./logo_bind.svg?react")).default;
  }

  async getSidebarPageSmallLogo() {
    return (await import("./sidebar-page-small-logo.tsx")).default;
  }

  getCode(): string {
    return bindGarantiasTenant;
  }

  getPathLabel(): string | null {
    return "bind";
  }

  getLabel(): string {
    return bindGarantiasLabel;
  }

  getFullLabel(): string {
    return bindGarantiasFullLabel;
  }

  getOnboardingOptions(): OnboardingOptions {
    return bindOnboardingOptions;
  }

  getLineOptions(): LineOptions {
    return bindGarantiasLineOptions;
  }

  getNotificationsFrom(): string {
    return "no-responder@matchfin.ar";
  }

  getCuit(): string | null {
    return "30-70860991-5";
  }

  publishesInMarketplace(): boolean {
    return true;
  }

  hasGrantedLineSection(): boolean {
    return true;
  }

  getDocumentsToFulfill(): DocumentToFulfill[] {
    return documentsToFulfill;
  }
}

const bindGarantiasTenantHandler = new BindGarantiasTenantHandler();

export default bindGarantiasTenantHandler;
